export const MetabaseAnalyticsPageReportNames = {
    Volume: 'volume',
    Tasks: 'tasks',
} as const;

export type MetabaseAnalyticsPageReportName =
    (typeof MetabaseAnalyticsPageReportNames)[keyof typeof MetabaseAnalyticsPageReportNames];

export interface UpdateFilterSelectionRequest {
    data: Record<string, string | string[]>;
    report: MetabaseAnalyticsPageReportName;
}

export type AnalyticsTrialRequest = {
    teamId: string;
};

export const ANALYTICS_TRIAL_STATUSES = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    EXPIRED: 'EXPIRED',
    INELIGIBLE: 'INELIGIBLE',
} as const;

type AnalyticsTrialStatusType = (typeof ANALYTICS_TRIAL_STATUSES)[keyof typeof ANALYTICS_TRIAL_STATUSES];

export type AnalyticsTrialStatusRawResponse = {
    status: AnalyticsTrialStatusType;
    expires_at: number;
};

export type AnalyticsTrialStatusResponse = {
    status: AnalyticsTrialStatusType;
    expiresAt: number;
};
